"use strict";

import jQuery from 'jquery';

/**
 * @namespace gc.gis.action.layercatalog
 */
gc.gis.action.layercatalog = gc.gis.action.layercatalog || {};

/**
 * @classdesc
 * Layer-Katalog-Modul.
 *
 * @class
 * @extends gc.gis.module.GCAbstractModule
 * @memberof gc.gis.module
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {gc.gis.map.GCMapView} [options.map={@link gc.gis.GCApplication#map}]
 * @param {string} [options.label='Kartenkatalog']
 * @param {boolean} [options.internalLayerSupport=false]
 * @param {boolean} [options.externalLayerSupport=false]
 * @param {string} [options.requests.catalogUpdateUrl]
 * @param {string} [options.requests.catalogSearchUrl]
 */
gc.gis.module.GCLayerCatalog = function(options)
{
	gc.gis.module.GCAbstractModule.call(this, options);

	this.label = options.label || 'Kartenkatalog';
	this.internalLayerSupport = gc.gis.GCUtil.parseBool(options.internalLayerSupport, false);
	this.externalLayerSupport = gc.gis.GCUtil.parseBool(options.externalLayerSupport, false);
	if (this.internalLayerSupport && options.requests)
	{
		this.update_url = options.requests.catalogUpdateUrl;
		this.search_url = options.requests.catalogSearchUrl;
	}
	this.map = options.map || gc.gis.iface.map;
	this.requestManager = options.requestManager || gc.gis.iface.request;
	this.active = gc.gis.GCUtil.parseBool(options.active, false);

	this._render();
	this._initEvents();
};
gc.gis.module.GCLayerCatalog.prototype = Object.create(gc.gis.module.GCAbstractModule.prototype);

/**
 * @return {jQuery}
 */
gc.gis.module.GCLayerCatalog.prototype.getElement = function()
{
	return this.element_panel.getElement();
};

/**
 * @return {jQuery}
 */
gc.gis.module.GCLayerCatalog.prototype._render = function()
{
	const panelOptions = {
		className: 'gc-layercatalog',
		//target: '#gc_layercatalog'
	};

	if (this.internalLayerSupport && this.externalLayerSupport)
	{
		panelOptions.toolbar = new gc.gis.widget.GCMenu({
			items: [
				new gc.gis.widget.GCRadioItem({
					active: true,
					label: 'Kartenkatalog',
					group: 'layercatalog_toolbar',
					className: 'btn btn-default',
					icon: 'toolbar-action-internal',
					action: new gc.gis.action.layercatalog.ShowInternalTab(this)
				}),
				new gc.gis.widget.GCRadioItem({
					label: 'Externe Daten',
					group: 'layercatalog_toolbar',
					className: 'btn btn-default',
					icon: 'toolbar-action-external',
					action: new gc.gis.action.layercatalog.ShowExternalTab(this)
				})
			]
		});
	}
	this.element_panel = new gc.gis.widget.GCPanel(panelOptions);

	if (this.internalLayerSupport)
	{
		this._internalLayerPanel = new gc.gis.module.GCLayerCatalog.Panel({
			module: this
		});
		this.element_panel.getElement().append(this._internalLayerPanel.getElement());
		this.updateInternalCatalog();
	}

	if (this.externalLayerSupport)
	{
		this._externalLayerPanel = new gc.gis.module.GCLayerCatalog.ExternalPanel({
			module: this,
			requestManager: this.requestManager,
			mapView: this.map
		});
		this.element_panel.getElement().append(this._externalLayerPanel.getElement());

		if (this.internalLayerSupport)
		{
			this.showInternalLayerPanel();
		}
	}
};

gc.gis.module.GCLayerCatalog.prototype._initEvents = function()
{
	const self = this;
	gc.gis.iface.onModuleAvailable(this, 'GCLayerTree', function(module) {
		gc.gis.iface.log.debug(self, 'GCLayerCatalog: Adding toolbar action to GCLayerTree ... ');

		self._sidebar_content = new gc.gis.ui.GCSidebarContent({
			label: 'Ebene laden',
			element:  self.getElement(),
			'parent': module._sidebar_content,
			launcher: module._sidebar_content.getLauncher()
		});

		module.getMainPanel().getToolbar().addItem(new gc.gis.widget.GCItem({
			label: 'Ebene laden',
			className: 'btn btn-default',
			icon: 'toolbar-action-addlayer',
			click: function(evt) {
				gc.gis.iface.ui.sidebar.setContent(self._sidebar_content);
			}
		}));
	});
};

/**
 * @public
 * @method
 * @return {gc.gis.module.GCLayerCatalog.Panel}
 */
gc.gis.module.GCLayerCatalog.prototype.getInternalLayerPanel = function()
{
	return this._internalLayerPanel;
};

/**
 * @public
 * @method
 * @return {gc.gis.module.GCLayerCatalog.ExternalPanel}
 */
gc.gis.module.GCLayerCatalog.prototype.getExternalLayerPanel = function()
{
	return this._externalLayerPanel;
};

/**
 * Zeigt das Panel für die internen Layer an und blendet ggf. das Panel für die externen Layer aus.
 *
 * @public
 * @method
 */
gc.gis.module.GCLayerCatalog.prototype.showInternalLayerPanel = function()
{
	if (this._internalLayerPanel)
	{
		if (this._externalLayerPanel)
		{
			const element = this._externalLayerPanel.getElement();
			element.hide();
			element.removeClass('active');
		}
		const element = this._internalLayerPanel.getElement();
		element.show('blind');
		element.addClass('active');
	}
};

/**
 * Zeigt das Panel für die externen Layer an und blendet ggf. das Panel für die internen Layer aus.
 *
 * @public
 * @method
 */
gc.gis.module.GCLayerCatalog.prototype.showExternalLayerPanel = function()
{
	if (this._externalLayerPanel)
	{
		if (this._internalLayerPanel)
		{
			const element = this._internalLayerPanel.getElement();
			element.hide();
			element.removeClass('active');
		}
		const element = this._externalLayerPanel.getElement();
		element.show('blind');
		element.addClass('active');
	}
};

/**
 * Feuert einen Ajax-Request ab, der den aktuellen Katalog bezieht und
 * anschließend dargestellt wird.
 *
 * @public
 * @method
 */
gc.gis.module.GCLayerCatalog.prototype.updateInternalCatalog = function()
{
	const self = this;

	this.beforeUpdateStart();

	gc.gis.iface.request.ajax({
		label: 'Aktualisiere Kartenkatalog ... ',
		context: this,
		url: self.update_url,
		success: function( result, statusCode, xhr) {
				const json = JSON.parse(result);
				self.afterUpdateComplete(json.results);
		},
		error: function( err ) {
			self.afterUpdateError( err );
		}
	});
};

/**
 * Feuert einen Ajax-Request zum suchen von Layern ab.
 *
 * @public
 * @method
 *
 * @param {string} name Suchbegriff
 */
gc.gis.module.GCLayerCatalog.prototype.findInternalLayers = function(name)
{
	const self = this;

	this.beforeSearchStart();

	gc.gis.iface.request.ajax({
		label: 'Suche im Kartenkatalog nach "'+ name +'" ... ',
		context: this,
		url: gc.gis.GCUrl.buildUrl(self.search_url, {'name': name}),
		success: function( result ) {
            const json = JSON.parse( result );
            self.afterSearchComplete( json.results, name );
		},
		error: function( err ) {
			self.afterSearchError( err );
		}
	});
};

/**
 * Grast angehakte Layer-Checkboxen ab, und läd die zugehörigen Layer in die
 * Karte.
 *
 * @public
 * @method
 */
gc.gis.module.GCLayerCatalog.prototype.loadInternalLayers = function()
{
	const items = this._internalLayerPanel.form_internal.find('.gc-item input:checked');

	if (items.length > 0)
	{
		for (let i = 0; i < items.length; i++)
		{
			const l = jQuery(items[i]).data('__layer');
			if (l.checked === true)
			{
				this.map.loadLayer(l);
			}
		}

		this.map.updateMap();
	}
	else
	{
		throw new gc.gis.error.GCError('Keine Ebenen ausgewählt');
	}
};

/**
 * Callback, bevor der Katalog aktualisiert wird.
 *
 * @public
 * @method
 */
gc.gis.module.GCLayerCatalog.prototype.beforeUpdateStart = function()
{
	this._internalLayerPanel.showLoadingAnimation('Lade Inhalte... ');
};

/**
 * Callback, nachdem der Katalog aktualisiert wurde.
 *
 * @public
 * @method
 *
 * @param {Array<Object>} results Ergebnisliste
 */
gc.gis.module.GCLayerCatalog.prototype.afterUpdateComplete = function( results )
{
	this._internalLayerPanel.renderInternalLayerTree( results );
};

/**
 * Callback, wenn beim aktualisieren des Katalogs ein Fehler aufgetreten ist.
 *
 * @public
 * @method
 *
 * @param {Error} err Aufgetretener Fehler
 */
gc.gis.module.GCLayerCatalog.prototype.afterUpdateError = function( err )
{
	this._internalLayerPanel.showError( err );
};

/**
 * Callback, bevor die Katalogsuche gestarted wird.
 *
 * @public
 * @method
 */
gc.gis.module.GCLayerCatalog.prototype.beforeSearchStart = function()
{
	this._internalLayerPanel.showLoadingAnimation('Suche läuft... ');
};

/**
 * Callback, nachdem die Katalogsuche beendet wurde.
 *
 * @public
 * @method
 *
 * @param {Array<Object>} results JSON-Ergebnis-Liste
 * @param {string} name Suchbegriff
 */
gc.gis.module.GCLayerCatalog.prototype.afterSearchComplete = function( results, name )
{
	this._internalLayerPanel.renderInternalLayerTree( results, name, name !== '' );
};

/**
 * Callback, wenn bei der Katalogsuche ein Fehler aufgetreten ist.
 *
 * @public
 * @method
 *
 * @param {Error} err Aufgetretener Fehler
 */
gc.gis.module.GCLayerCatalog.prototype.afterSearchError = function( err )
{
	this._internalLayerPanel.showError( err );
};


///////////////
//  ACTIONS  //
///////////////

/**
 * @param {gc.gis.module.GCLayerCatalog} layerCatalouge
 */
gc.gis.action.layercatalog.ShowInternalTab = function(layerCatalouge)
{
	gc.gis.action.GCAbstractAction.call(this);

	const self = this;
	this.func = function()
	{
		layerCatalouge.showInternalLayerPanel();
		jQuery(self.target).addClass('active');
	};
	this.args = [];
};
gc.gis.action.layercatalog.ShowInternalTab.prototype = Object.create( gc.gis.action.GCAbstractAction.prototype );


/**
 * @param {gc.gis.module.GCLayerCatalog} layerCatalouge
 */
gc.gis.action.layercatalog.ShowExternalTab = function(layerCatalouge)
{
    gc.gis.action.GCAbstractAction.call(this);

	const self = this;
	this.func = function()
	{
		layerCatalouge.showExternalLayerPanel();
		jQuery(self.target).addClass('active');
	};
	this.args = [];
};
gc.gis.action.layercatalog.ShowExternalTab.prototype = Object.create( gc.gis.action.GCAbstractAction.prototype );


/**
 * @param {gc.gis.module.GCLayerCatalog} layerCatalouge
 */
gc.gis.action.layercatalog.LoadInternalLayers = function(layerCatalouge)
{
    gc.gis.action.GCAbstractAction.call( this );

	const self = this;
	this.catalog = layerCatalouge;

	this.func = function()
	{
		self.catalog.loadInternalLayers();
		self.catalog.getInternalLayerPanel().resetInternalForm();
		gc.gis.iface.ui.sidebar.historyBack();
	};
	this.args = [];
};
gc.gis.action.layercatalog.LoadInternalLayers.prototype = Object.create( gc.gis.action.GCAbstractAction.prototype );

/**
 * @param {gc.gis.module.GCLayerCatalog} layerCatalouge
 */
gc.gis.action.layercatalog.ResetInternalLayers = function(layerCatalouge)
{
    gc.gis.action.GCAbstractAction.call( this );

	const self = this;
	this.catalog = layerCatalouge;

	this.func = function()
	{
		self.catalog.getInternalLayerPanel().resetInternalForm();
	};
	this.args = [];
};
gc.gis.action.layercatalog.ResetInternalLayers.prototype = Object.create( gc.gis.action.GCAbstractAction.prototype );
